// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__32xeO","sidebarTitle":"Sidebar_sidebarTitle__DlLz9","sidebarLinks":"Sidebar_sidebarLinks__jl1zr"};